module.exports = __webpack_public_path__ + "img/phones-frame.148b97ea.gif";